import { agentsClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

import type { MetaAttributeGroupApi, MetaCatalogGroup } from '../types/meta-catalog.types';

/**
 * Fetch the Meta attribute catalogue from the meta agent. Defaults to
 * `include_pass_through=false` — the 10 fields the agent copies untouched are not
 * something enrichment "does", so a disclosure panel leaves them out (per #402).
 * Returns groups in catalogue order with the wire shape normalised to camelCase.
 */
export async function fetchMetaCatalogAttributes(
  includePassThrough = false,
): Promise<MetaCatalogGroup[]> {
  const groups = await agentsClient
    .get(endpoints.agents.metaCatalogAttributes(), {
      searchParams: { include_pass_through: includePassThrough },
    })
    .json<MetaAttributeGroupApi[]>();

  return groups.map((group) => ({
    id: group.group,
    label: group.group_label,
    attributes: [...group.attributes]
      .sort((a, b) => a.sort_order - b.sort_order)
      .map((attr) => ({
        key: attr.key,
        label: attr.display_name,
        generation: attr.generation,
        selectable: attr.selectable,
        controlChannel: attr.control_channel,
        enumValues: attr.enum_values,
        requires: attr.requires,
        note: attr.note,
      })),
  }));
}
